// extracted by mini-css-extract-plugin
export default {"cell":"Segment-cell-ebcd"};